import Cookies from 'js-cookie'
//js-cookie一定程度上能够代替localstorage的作用，并且提供了某些便利，以下是二者的区别：
//通常来说，cookie是由浏览器自动管理，对于开发者而言是不可见的，js-cookie库则提供了直接操作cookie的api
//js-cookie会将内容放在浏览器的请求cookie当中，这意味着每次请求时都会在cookie字段发送内容，
//因此cookie的容积比localstorage还要小，不过，虽然后端总会接收到cookie字段，但是后端可以选择无视这些内容
//cookie可以设置过期时间，比如Cookies.set('name', 'value', { expires: 7 });设置一个 7 天后过期的 Cookie;
//如果调用 Cookies.set(key, value) 而不指定过期时间，那么创建的 Cookie 将是会话 Cookie（session cookie）
//这意味着：会话 Cookie 会在浏览器会话结束时过期。具体来说，当用户关闭浏览器窗口或标签页时，这些 Cookie 会被删除。
//localstorage不会过期，除非显式地进行remove，这是同cookie主要的区别，
//不会过期的特性可能导致一些潜在的bug，也意味着程序员需要付出额外的精力来管理资源的正确释放。
//可惜二者都不是集中化管理的，因此建议类似这个文件一样，将对set或get方法的调用集中到一个文件当中
const TokenKey = 'business-token'
export function getToken() {
  return Cookies.get(TokenKey)
}
export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}
